import React from 'react';
import FadeUp from '../ui/FadeUp';
import SafeIcon from '@/common/SafeIcon';

export default function Areas() {
  const areas = [
    'Salisbury', 'Fruitland', 'Delmar', 'Parsonsburg', 
    'Pittsville', 'Ocean Pines', 'Berlin', 'Ocean City', '& More'
  ];

  return (
    <section id="areas" className="section-padding bg-dark">
      <FadeUp className="max-w-[600px] mb-16">
        <div className="font-condensed text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4">Coverage</div>
        <h2 className="font-condensed font-black text-[clamp(36px,4vw,56px)] uppercase leading-none mb-5 text-white">Areas We Serve</h2>
        <p className="text-text-muted text-[18px] leading-relaxed font-medium">
          Proudly serving Salisbury and communities across the Eastern Shore of Maryland.
        </p>
      </FadeUp>

      <FadeUp className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {areas.map((area, i) => (
          <div key={i} className="bg-dark-2 border-2 border-dark-4 py-4 px-6 rounded-md font-condensed font-bold text-[17px] uppercase tracking-wide text-text-muted flex items-center gap-3 transition-all hover:border-gold hover:text-white hover:bg-dark-3 cursor-default">
            <SafeIcon name="MapPin" className="text-gold text-lg" />
            {area}
          </div>
        ))}
      </FadeUp>

      <FadeUp className="mt-10 text-text-muted text-[16px] font-medium">
        Not sure if we serve your area? <a href="tel:4433592010" className="text-gold no-underline font-bold hover:underline transition-all">Give us a call</a> — we'll let you know!
      </FadeUp>
    </section>
  );
}